import { useTheme } from "@emotion/react";
import { themeGet } from "@styled-system/theme-get";
import {
  ErrorAlt as ErrorIcon,
  SuccessAlt as SuccessIcon,
  WarningAlt as WarningIcon,
} from "@mos-cat/ds-icons";
import { pxToRem } from "@mos-cat/ds-theme";
import { Box } from "../Box/Box";
import type { InfoModalType } from "./types";

export function InfoModalIcon({ kind }: { kind: InfoModalType }) {
  let theme = useTheme();

  let Icon = {
    error: ErrorIcon,
    warning: WarningIcon,
    success: SuccessIcon,
  };

  function getIconBackground() {
    /* eslint-disable @typescript-eslint/no-unsafe-assignment -- У themeGet убогий тип, и мы не можем с этим ничего сделать */
    const internalColor: string = themeGet(`colors.infoModal-${kind}-InternalRingColor`)({ theme });
    const externalColor: string = themeGet(`colors.infoModal-${kind}-ExternalRingColor`)({ theme });
    /* eslint-enable @typescript-eslint/no-unsafe-assignment -- Продолжаем проверять */

    return `radial-gradient(
        circle,
        transparent ${pxToRem(14)},
        ${internalColor} ${pxToRem(14)}, ${internalColor} ${pxToRem(16)},
        ${externalColor} ${pxToRem(16)}, ${externalColor} ${pxToRem(20)}
      )`;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- у themeGet убогий тип, и мы не можем с этим ничего сделать
  const iconColor: string = themeGet(`colors.infoModal-${kind}-Color`)({
    theme,
  });
  const iconBackground = getIconBackground();
  return (
    <Box
      borderRadius="round"
      background={iconBackground}
      size={["infoModalIconBlockSmall", "infoModalIconBlock"]}
      display="flex"
      alignItems="center"
      justifyContent="center"
      styles={{
        "& circle": {
          fill: iconColor,
        },
      }}
    >
      <Box as={Icon[kind]} size={["infoModalIconSizeSmall", "infoModalIconSize"]} />
    </Box>
  );
}
